import React, { useState } from "react";
import { api } from "../api";

// Staging-only UI. Backend must additionally enable an allowlisted confirmation pilot.
export default function NewsletterFooterPilotV1({ lang = "en" }) {
  const fr = String(lang || "").toLowerCase().startsWith("fr");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  // Reflect the native disabled condition visibly; the footer style previously looked active.
  const submitDisabled = busy || !email.trim() || !consent;
  const submit = async (event) => {
    event.preventDefault();
    setNotice(""); setError("");
    if (!consent) {
      setError(fr ? "Veuillez accepter de recevoir la newsletter." : "Please opt in to receive the newsletter.");
      return;
    }
    setBusy(true);
    try {
      const result = await api.post("/api/newsletter/subscribe", {
        email: email.trim(), consent, language: fr ? "fr" : "en",
      });
      setNotice(result?.message || (fr ? "Vérifiez votre e-mail." : "Check your email."));
      setEmail(""); setConsent(false);
    } catch (err) {
      setError(String(err?.message || (
        fr ? "Votre inscription n’a pas pu aboutir. Veuillez réessayer plus tard." :
        "We couldn’t complete your subscription. Please try again later."
      )));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section
      data-newsletter-footer-pilot-v1="true"
      aria-label={fr ? "S'abonner à notre newsletter" : "Subscribe to Our Newsletter"}
      style={{
        maxWidth: 1140, margin: "0 auto", padding: "22px 22px 26px",
        borderTop: "1px solid rgba(15,95,53,0.17)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 18, alignItems: "flex-start" }}>
        <div style={{ flex: "1 1 260px" }}>
          <h2 style={{ color: "#204b34", fontFamily: "Georgia,serif", fontSize: 22, margin: "0 0 9px" }}>
            {fr ? "Abonnez-vous à notre newsletter" : "Subscribe to Our Newsletter"}
          </h2>
          <div data-newsletter-description-v1="true" style={{ color: "#365746", maxWidth: 420, margin: 0, lineHeight: 1.55, fontSize: 15 }}>
            {fr
              ? "Actualités NextScenes, conseils d’écriture et nouvelles créations. Occasionnellement et sans pression."
              : "NextScenes updates, writing inspiration and new creative works. Occasional emails, never a daily obligation."}
          </div>
        </div>
        <form onSubmit={submit} style={{ display: "grid", gap: 9, flex: "1 1 320px", maxWidth: 470 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 9 }}>
            <label htmlFor="ns-newsletter-email" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clipPath: "inset(50%)" }}>
              {fr ? "Votre adresse e-mail" : "Email address"}
            </label>
            <input id="ns-newsletter-email" type="email" required maxLength={254}
              placeholder={fr ? "Votre adresse e-mail" : "Your email address"}
              autoComplete="email" value={email} onChange={e => setEmail(e.target.value)}
              disabled={busy}
              style={{ flex: "1 1 185px", minWidth: 140, padding: "11px 13px", borderRadius: 10, border: "1px solid #b5c8b6", background: "#fff" }}/>
            <button type="submit" disabled={submitDisabled}
              data-newsletter-ready={submitDisabled ? "false" : "true"}
              style={{ border: 0, padding: "11px 18px", borderRadius: 10,
                background: submitDisabled ? "#a5b8a7" : "#0f5f35",
                color: submitDisabled ? "#385442" : "#fff",
                cursor: submitDisabled ? "not-allowed" : "pointer",
                opacity: submitDisabled ? 0.65 : 1,
                boxShadow: submitDisabled ? "none" : "0 3px 9px rgba(8,67,36,0.12)",
                fontWeight: 800 }}>
              {busy ? (fr ? "Envoi…" : "Submitting…") : (fr ? "S'abonner" : "Subscribe")}
            </button>
          </div>
          <label style={{ color: "#395544", fontSize: 13, display: "flex", alignItems: "flex-start", gap: 7 }}>
            <input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} disabled={busy} />
            {fr
              ? "J’accepte de recevoir la newsletter et les actualités NextScenes. Désabonnement possible à tout moment."
              : "I agree to receive the NextScenes newsletter and platform updates. I can unsubscribe at any time."}
          </label>
          {notice ? <div role="status" style={{ margin: 0, color: "#0f5f35" }}>{notice}</div> : null}
          {error ? <div role="alert" style={{ margin: 0, color: "#a32e2e" }}>{error}</div> : null}
        </form>
      </div>
    </section>
  );
}
